import React from "react";
import waterImg from "../images/waterImage.png";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import img from "../images/water_bottle.png";
import aqueducsImg from "../images/adequaduc.png";
import ecoWater from "../images/eco-water.png";
import ecoWater2 from "../images/eco2.png";
import drop1 from "../images/drop1.png";
import drop2 from "../images/drop2.png";
import fuite1 from "../images/fuite.png";
import fuite2 from "../images/fuite2.png";
import cover from "../images/saviez-vous.png";

import { Card, CardContent, CardTitle } from "../components/ui/card";
const Eco = () => {
  const ImagesList = [
    {
      id: "1",
      image: fuite2,
      title: "Linge",
    },

    {
      id: "2",
      image: fuite2,
      title: "Vaisselles",
    },
    {
      id: "3",
      image: fuite2,
      title: "Préparation de la nourriture",
    },

    {
      id: "4",
      image: fuite2,
      title: "Ménage (entretien jardin )",
    },
    {
      id: "5",
      image: fuite2,
      title: "Voiture",
    },
  ];
  return (
    <>
      <div className="">
        <section
          className="p-10 text-center lg:p-32 "
          style={{
            backgroundColor: "#f0fafe",
          }}
        >
          <h1 className="text-2xl font-bold text-center text-black md:text-4xl lg:text-7xl">
            {"Plus de la moitié de cet usage quotidien est réservé"}
          </h1>
        </section>

        <div className="relative mb-10 lg:mt-80">
          <div className="none lg:absolute top-[-430px] left-0 right-0 ml-auto mr-auto ">
            <div className="flex justify-center pt-5 pb-5">
              <div className="bg-aquaFoncé p-5">
                <img src={fuite1} alt="" className="w-full h-48" />
                <h1 className="mt-2 text-center text-white">Toilette</h1>
              </div>
              <div className="p-5 bg-[#56CAF5]">
                <img src={fuite2} alt="" className="w-full h-48" />
                <h1 className="mt-2 text-center text-white">Sanitaires</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="">
          {" "}
          <div className="bg-aquaFoncé pb-32">
            <h1 className="p-2 text-xl text-center text-white">
              Le reste se répartit entre
            </h1>
            <div className="flex flex-col justify-center lg:flex-row">
              {ImagesList.map((item) => (
                <div key={item.id} className="">
                  <svg
                    viewBox="0 0 200 200"
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-60 w-60 "
                  >
                    <path
                      fill="#56CAF5"
                      d="M45.6,6.7C45.6,33,22.8,66.1,-3.5,66.1C-29.9,66.1,-59.7,33,-59.7,6.7C-59.7,-19.5,-29.9,-39.1,-3.5,-39.1C22.8,-39.1,45.6,-19.5,45.6,6.7Z"
                      transform="translate(100 100)"
                    />
                    <image
                      xlinkHref={item.image}
                      id="A"
                      height={70}
                      width={100}
                      x={40}
                      y={80}
                    />
                  </svg>
                  <h1 className="text-center text-white">{item.title}</h1>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="relative pb-1 mt-10 mb-10 lg:mb-40 lg:mt-96 ">
          <div className="none lg:absolute top-[-430px] left-0 right-0 ml-auto mr-auto">
            <div className="">
              {" "}
              <div className="">
                <div className="flex justify-center ">
                  <Card>
                    <CardTitle className="p-8 text-center text-black">
                      Et en litres , ça fait combien ?
                    </CardTitle>
                    <CardContent>
                      <div className="grid gap-5 grid-rows lg:grid-cols-3">
                        <img
                          src={fuite2}
                          alt=""
                          className="border-2 h-52 w-60 border-primary"
                        />
                        <img
                          src={fuite2}
                          alt=""
                          className="border-2 h-52 w-60 border-primary"
                        />
                        <img
                          src={fuite2}
                          alt=""
                          className="border-2 h-52 w-60 border-primary"
                        />

                        <img
                          src={fuite2}
                          alt=""
                          className="border-2 h-52 w-60 border-primary"
                        />
                        <img
                          src={fuite2}
                          alt=""
                          className="border-2 h-52 w-60 border-primary"
                        />
                        <img
                          src={fuite2}
                          alt=""
                          className="border-2 h-52 w-60 border-primary"
                        />
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
        

 
        <div className="">
          {" "}
          <div className="container mx-auto md:px-40 sm:px-40 ">
            <img src={cover} alt="" />
            <p className="mt-20 text-black">
              Comme cette eau est précieuse il ne faut pas la gaspiller ni la
              polluer avec des substances(solvants, peintures, médicaments....)
              qui risqueraient de perturber le cycle de dépollution. Les eaux
              usées sont comme un déchet qu'il faut trier avant de les jeter dans les
              canalisations !
            </p>

            <h1 className="mt-8 font-bold text-black">
              Pour éviter le gaspillage, sachez qu’il vaut mieux prendre
            </h1>
            <div className="grid mt-5 justify-items-center">
              <img src={ecoWater} alt="" className=" w-96 h-80" />

              <h1 className="mt-8 font-bold text-black">
                Comment repérer une fuite ?
              </h1>
            </div>

            <div className="flex flex-col justify-center md:flex-row">
              <div className="flex items-center ">
                Principales causes d’une consommation excessive, les fuites
                d’eau doivent être traquées. La chasse au gaspillage est
                ouverte. Pour cela, entretenez régulièrement les canalisation et
                robinets chez vous afin de prévenir d’éventuelles fuites.
              </div>
              <div>
                <img src={ecoWater2} alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="">
          {" "}
          <div className="pt-5 pb-20 bg-bg_aquavesc">
            <h1 className="p-2 text-2xl font-bold text-center text-black">
              Un moyen efficace de les repérer
            </h1>
            <div className="grid ml-5 mr-10 lg:grid-cols-3 justify-items-center">
              <div className="grid grid-cols-1">
                <div className="flex justify-center">
                  <img src={drop1} alt="" className="h-50 w-60" />
                </div>
                <h1 className="text-black text-start">
                  Relevez le soir les chiffres inscrits sur votre compter
                </h1>
              </div>
              <div className="grid grid-cols-1">
                <div className="flex justify-center">
                  <img src={drop2} alt="" className="h-50 w-60" />
                </div>
                <h1 className="text-black text-start">
                  Pendant la nuit, assurez-vous de ne pas consommer d’eau, en
                  évitant de programmer une machine à laver par exemple
                </h1>
              </div>

              <div className="grid grid-cols-1">
                <div className="flex justify-center">
                  <img src={drop1} alt="" className="h-50 w-60" />
                </div>
                <h1 className="text-black text-start">
                  Le lendemain matin, si vous constatez que les chiffres ont
                  changé, c’est qu’il y a une fuite
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Eco;
